import type { SVGProps } from 'react';

const SvgMedal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14.5004 21.5002"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.022 9.1952L13.7502 0.750196L10.022 9.1952ZM5.06628 9.3825L0.750164 0.750196L5.06628 9.3825ZM8.51166 8.7981L4.58516 0.750196L8.51166 8.7981ZM10.1102 0.750196L9.07016 3.2502L10.1102 0.750196ZM1.75016 14.7502C1.75016 18.0639 4.43645 20.7502 7.75016 20.7502C11.0639 20.7502 13.7502 18.0639 13.7502 14.7502C13.7502 11.4365 11.0639 8.7502 7.75016 8.7502C4.43645 8.7502 1.75016 11.4365 1.75016 14.7502Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgMedal;
